<template>
  <div>
    <div class="mt-5" v-if="loading">
      <px-circular-loading/>
    </div>
    <v-list v-if="!loading">
      <template v-for="(produto, index) in produtos">
        <v-list-item
          :key="produto.id"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-row dense>
                <v-col cols="12" sm="2">
                  <px-indicador-compra is-produto class="mr-2" :resposta="produto"/>
                  <px-span-tooltip v-if="checkCodigo(produto.cotacaoProduto.produto)"
                          top
                          :text="labelCodigo(produto.cotacaoProduto.produto)"
                          tooltip="Código interno"/>
                </v-col>
                <v-col cols="12" sm="6" class="text-truncate">
                  {{ produto.cotacaoProduto.produto.descricao }}
                  ({{ produto.cotacaoProduto.quantidade
                  | number(getCurrencyFormat(produto.cotacaoProduto.produto.casasDecimais)) }}
                  {{ produto.cotacaoProduto.unidadeMedida.descricao }})
                </v-col>
                <v-col cols="12" sm="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div>
                        <span v-on="on">
                        {{ produto.valorMoedaConvertido.precoUnitario |
                          currency('R$', produto.cotacaoProduto.produto.casasDecimais) }}
                      </span>
                        <div class="caption" v-if="isMoedaEstrangeira">
                          {{ produto.precoUnitario |
                          currency(simboloMoeda,
                          produto.cotacaoProduto.produto.casasDecimais,
                          configuracaoFormatacaoMoeda) }}
                        </div>
                      </div>

                    </template>
                    <span>Preço unitário</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div v-on="on">
                        {{ produto.valorMoedaConvertido.total | currency('R$',
                          produto.cotacaoProduto.produto.casasDecimais) }}
                        <div class="caption" v-if="isMoedaEstrangeira">
                          {{ produto.total |
                          currency(simboloMoeda,
                          produto.cotacaoProduto.produto.casasDecimais,
                          configuracaoFormatacaoMoeda) }}
                        </div>
                      </div>
                    </template>
                    <span>Preço total</span>
                  </v-tooltip>
                  <px-situacao-cotacao-produto :situacao="produto.situacao" />
                </v-col>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
          <div>
            <px-preco-target
              :produto="produto.cotacaoProduto"/>
            <px-especificacao-produto-comparavel
              :especificacao="produto.cotacaoProduto.especificacaoProduto"
              :especificacao-fornecida="produto.especificacaoProduto"/>
            <px-historico-preco-produto
              :produto="produto.cotacaoProduto.produto"
              :unidade-medida="produto.cotacaoProduto.unidadeMedida"/>
          </div>
        </v-list-item>
        <v-divider v-if="showDivider(index)" :key="`v-div${produto.id}`"/>
      </template>
    </v-list>
  </div>
</template>

<script>
import { CasaDecimalUtils } from 'px-components';
import moedaMixin from '@/mixins/moeda-mixin';
import RespostaService from './resposta-service';

export default {
  mixins: [moedaMixin],
  props: {
    resposta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      produtos: null,
    };
  },
  computed: {
    moeda() {
      return this.resposta.moeda;
    },
    showDivider() {
      return index => index !== (this.produtos.length - 1);
    },
    getCurrencyFormat() {
      return item => CasaDecimalUtils.getCurrencyFormat(item);
    },
    labelCodigo() {
      return item => item.codigo;
    },
    checkCodigo() {
      return item => item.codigo;
    },
  },
  methods: {
    getProdutos() {
      this.loading = true;
      RespostaService.getProdutos(this.resposta.cotacao.id, {
        query: `respostaCotacao.id=${this.resposta.id} order by id`,
      })
        .then((response) => {
          this.produtos = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getProdutos();
  },
};
</script>
